import PropTypes from 'prop-types'
import React from 'react'

import AccessibilityIcon from './AccessibilityIcon.svg'
import s from './TallinkSiljaHeader.module.scss'
import TallinkSiljaLogo from './TallinkSiljaLogo.svg'

export default function TallinkSiljaHeader({ accessibilityUrl, ariaLabelTranslation }) {
  return (
    <header className={s['tallink-silja-header']}>
      <div className={s['tallink-silja-logo-placeholder']}>
        <img alt="Tallink | Silja Line" src={TallinkSiljaLogo} />
      </div>
      {accessibilityUrl && (
        <a
          aria-label={ariaLabelTranslation}
          className={s['accessibility-icon']}
          href={accessibilityUrl}
          target="_blank"
        >
          <img alt="" src={AccessibilityIcon} />
        </a>
      )}
    </header>
  )
}

TallinkSiljaHeader.propTypes = {
  accessibilityUrl: PropTypes.string,
  ariaLabelTranslation: PropTypes.string
}
